// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2o-da","question":"Question_question__23yI5","description":"Question_description__1dN3b"};